import {ReactComponent as CorgiTp} from './icons/corgi-wrapped-in-tp.svg';
import PooTypes from './poo_types.json';
import {Button} from '@mui/material';
import React from "react";
import $ from 'jquery';

class PopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeStop: new Date().getTime()
    };
  }

  click = (event) => {
    this.props.toggle();
    let type = event.target.getAttribute('poo-type')
    // console.log('Selected: ' + type)
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'poo_submit',
        pooType: type.slice(-1),
        stopTime: this.state.timeStop,
        message_id: $('.poo_submit').val()
      },
      cache: false,
      success: function(html) {
      }
    });
    window.location.reload(false);
  };

  pooType() {
    var res = []
    for(let type in PooTypes){
      res.push(
        <div key={type} className="poo-type">
          <Button className="poo-type-btn" variant="outlined" onClick={this.click} poo-type={type}>{type.slice(-1)}</Button>
          <span>{PooTypes[type].description}</span>
        </div>
      );
    };
    return res
  }

  render() {
    return (
      <div className="modal">
        <div className="modal_content">
          <CorgiTp className="corgi-Tp" width="10%" />
          <h2>Select Your Poo Type</h2>
          <p className="whisper">Review the 7 types below and choose the closest match.</p>
          <div className="poo-selections">
            {
              this.pooType()
            }
          </div>
        </div>
      </div>
    );
  }
}

export default PopUp
